import { lazyPage } from './lazyPage';
import type { AppRoute } from './types';

const PrincipalDashboard = lazyPage(() => import('@/pages/portal/PrincipalPortal'));
const SchoolOverview = lazyPage(() => import('@/pages/principal/SchoolOverview'));
const StudentSummary = lazyPage(() => import('@/pages/principal/StudentSummary'));
const FacultyOverview = lazyPage(() => import('@/pages/principal/FacultyOverview'));
const AttendanceOverview = lazyPage(() => import('@/pages/principal/AttendanceOverview'));
const AcademicPerformance = lazyPage(() => import('@/pages/principal/AcademicPerformance'));
const PrincipalExaminationResults = lazyPage(() => import('@/pages/principal/ExaminationResults'));
const Discipline = lazyPage(() => import('@/pages/principal/Discipline'));
const Approvals = lazyPage(() => import('@/pages/principal/Approvals'));
const ParentIssues = lazyPage(() => import('@/pages/principal/ParentIssues'));
const StaffManagement = lazyPage(() => import('@/pages/principal/StaffManagement'));
const PrincipalReports = lazyPage(() => import('@/pages/principal/Reports'));
const MyProfile = lazyPage(() => import('@/pages/me/MyProfilePage'));

export const principalRoutes: AppRoute[] = [
  {
    path: 'principal',
    title: 'Principal Portal',
    children: [
      { path: '', title: 'Principal Portal', redirectTo: '/principal/dashboard' },
      { path: 'dashboard', title: 'Dashboard', component: PrincipalDashboard },
      { path: 'school-overview', title: 'School Overview', component: SchoolOverview },
      { path: 'student-summary', title: 'Student Summary', component: StudentSummary },
      { path: 'faculty-overview', title: 'Faculty Overview', component: FacultyOverview },
      { path: 'attendance-overview', title: 'Attendance Overview', component: AttendanceOverview },
      { path: 'academic-performance', title: 'Academic Performance', component: AcademicPerformance },
      { path: 'examination-results', title: 'Examination Results', component: PrincipalExaminationResults },
      { path: 'discipline', title: 'Discipline', component: Discipline },
      { path: 'approvals', title: 'Approvals', component: Approvals },
      { path: 'parent-issues', title: 'Parent Issues', component: ParentIssues },
      { path: 'staff-management', title: 'Staff Management', component: StaffManagement },
      { path: 'reports', title: 'Reports', component: PrincipalReports },
      { path: 'my-profile', title: 'My Profile', component: MyProfile },
    ],
  },
];
